import DataTableHeader_vue_vue_type_script_setup_true_lang_default from "./DataTableHeader.vue.script.js";
//#region src/v2/components/data-table/DataTableHeader.vue
var DataTableHeader_default = DataTableHeader_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { DataTableHeader_default as default };

//# sourceMappingURL=DataTableHeader.vue.js.map